import { FunctionComponent } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { dismissPopover } from 'services/OverlayService'

const Selector:FunctionComponent<SelectorProps> = ({ atBottom, id, selected, title, type, expanded }) => (selected === undefined) ? null : (
  <div className='relative'>
    <input
      type='checkbox'
      name={id}
      id={id + '/' + atBottom}
      checked={expanded}
      data-action='expand'
      data-path={id}
      data-type='content'
      data-value={+!expanded}
      readOnly
    />
    <Checkbox
      onClick={(e) => {
        dismissPopover(e.target)
        e.stopPropagation()
      }}
      checked={!!selected}
      inputProps={{
        'data-action': 'select',
        'data-path': id,
        'data-type': type,
        'data-value': selected !== 0 ? 0 : 1,
        readOnly: true
      } as any}
      data-event-category='Accordion'
      data-event-action={selected ? 'Deselect' : 'Select'}
      data-event-label={title}
      data-help-item='accordionselector'
      data-help-position='left'
    />
  </div>
)

interface SelectorProps {
  atBottom:number;
  id:string;
  selected: number;
  title: string;
  type:string;
  expanded: boolean;
}

export default Selector
